import React, { useState } from "react";
import { normalizeMoney, parseMoney, rupees } from "../../../lib/auditMath";

export const MoneyInput = ({ id, value, onChange, onBlur, label, showLabel = false, disabled = false }) => {
  const [focused, setFocused] = useState(false);
  const parsed = parseMoney(value);
  const display = focused || parsed.error || parsed.value === null ? value : rupees(parsed.value);
  return <div className="audit-money">
    {showLabel && <label htmlFor={id} data-testid={`${id}-label`} className="audit-input-label">{label}</label>}
    <input id={id} data-testid={id} type="text" inputMode="numeric" autoComplete="off" disabled={disabled}
      aria-label={label} aria-invalid={!!parsed.error} aria-describedby={parsed.error ? `${id}-error` : undefined}
      placeholder={disabled ? "View only" : "₹ Enter amount"} value={display}
      onFocus={() => setFocused(true)} onChange={(e) => onChange(normalizeMoney(e.target.value))}
      onBlur={() => { setFocused(false); onBlur?.(); }} />
    {parsed.error && <p id={`${id}-error`} data-testid={`${id}-error`} role="alert" className="audit-error">{parsed.error}</p>}
  </div>;
};